import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Loader from '../pulse-loader/index';
import '../../styles/core.scss';
import css from './index.scss';
import boxCSS from './box.scss';
import SvgIcon from '../svg-icon/svg-icon';
import * as variants from './variants';

/**
 * The 3p school-roll button.
 *
 * @version 1.0.1
 * @author Voyager
 */
const Button = ({ children, containerClassName = '', icon = '', iconClassName = '', label = '',
    disabled, hidden, loading, loadingLabel, handleOnClick,
    handleOnKeyPress, buttonContainer = '', buttonContainerDisabled = '', variant = '' }) => {
    let variantType = '';
    switch (variant) {
    case variants.ICON_ONLY: {
        variantType = css[variants.ICON_ONLY];
        iconClassName = css.iconOnlySvg;
        label = '';
        break;
    }
    case variants.CIRCLE_SUCCESS: {
        variantType = css[variants.CIRCLE_SUCCESS];
        iconClassName = css.circleIconSvg;
        label = '';
        break;
    }
    case variants.CIRCLE_DANGER: {
        variantType = css[variants.CIRCLE_DANGER];
        iconClassName = css.circleIconSvg;
        label = '';
        break;
    }
    case variants.DARK: {
        variantType = css[variants.DARK];
        iconClassName = css.darkIcon;
        break;
    }
    case variants.LIGHT: {
        variantType = css[variants.LIGHT];
        iconClassName = css.lightIcon;
        break;
    }
    case variants.DENIM: {
        variantType = css[variants.DENIM];
        iconClassName = css.lightIcon;
        break;
    }
    case variants.BOX_LIGHT: {
        variantType = boxCSS.BOX_LIGHT;
        iconClassName = boxCSS.icon;
        buttonContainer = boxCSS.wrapper;
        containerClassName = boxCSS.container;
        break;
    }
    default: {
        variantType = '';
    }
    }

    const iconElement = icon === ''
        ? <div />
        : <div className={iconClassName}><SvgIcon icon={icon} /></div>;

    const textElement = label === ''
        ? <div />
        : <span>{label}</span>;

    const buttonContent = children || textElement;

    const buttonContainerStyle = buttonContainer === ''
        ? css.buttonContainer
        : buttonContainer;

    const buttonContainerDisabledStyle = buttonContainerDisabled === ''
        ? css.buttonContainerDisabled
        : buttonContainerDisabled;

    const buttonStyle = disabled ? css.buttonContainerDisabled : buttonContainerStyle;

    const componentContainerDisabled = disabled ? `${css.componentDisabled}` : '';

    const buttonElement = loading
        ? <div className={buttonContainerDisabledStyle}>{iconElement}<span>{loadingLabel}</span><Loader size="5px" /></div>
        :
        (<div
            className={buttonStyle}
            hidden={hidden}
            onClick={handleOnClick}
            onKeyPress={handleOnKeyPress}
            role="button"
            tabIndex={0}>
            {iconElement}
            {buttonContent}
        </div>);

    const cointanerClasses = [containerClassName, variantType, componentContainerDisabled].join(' ');

    let finalView = (
        <div className={cointanerClasses}>
            {buttonElement}
        </div>);

    if (hidden) {
        finalView = <div />;
    }

    return finalView;
};

Button.propTypes = {
    label: PropTypes.string,
    children: PropTypes.node,
    containerClassName: PropTypes.string,
    icon: PropTypes.string,
    iconClassName: PropTypes.string,
    loadingLabel: PropTypes.string,
    buttonContainer: PropTypes.string,
    buttonContainerDisabled: PropTypes.string,
    disabled: PropTypes.bool,
    hidden: PropTypes.bool,
    loading: PropTypes.bool,
    handleOnClick: PropTypes.func,
    handleOnKeyPress: PropTypes.func,
    variant: PropTypes.string
};
export default styleable(css)(Button);



// WEBPACK FOOTER //
// ./app/components/button/index.js